export const makePortalWebUnitSelectionUrl = (
  widgetId: string,
  propertyId: string | undefined,
  locale: string,
): string => {
  const url = new URL(
    `${import.meta.env.VITE_PORTAL_WEB_ORIGIN}/widgets/${widgetId}/properties/${propertyId ? `${propertyId}/` : ""}unit-selection`,
  );

  url.searchParams.append(
    "elements",
    JSON.stringify({ hostUrl: location.host + location.pathname }),
  );

  url.searchParams.append("locale", locale);

  const hostSearchParams = new URLSearchParams(location.search);

  for (const parameter of ["_ga", "_gl", "fbclid", "gclid"]) {
    const value = hostSearchParams.get(parameter);

    if (value) {
      url.searchParams.set(parameter, value);
    }
  }

  return url.toString();
};
